import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Account from './views/Account.vue'
import Logoff from './views/Logoff.vue'
import Documents from './views/Documents.vue'
import Conditions from './views/Conditions.vue'
import Store from './store/index'

Vue.use(Router)

let routes = [
  {
    path: '/',
    name: 'signin',
    component: Home,
    beforeEnter: requireAuth,
    title: 'Login'
  },
  {
    path: '/signup',
    name: 'signup',
    component: Home,
    title: 'Sign Up'
  },
  {
    path: '/resetpassword',
    name: 'resetpassword',
    component: Home,
    title: 'Reset Password'
  },
  {
    path: '/forgotusername',
    name: 'forgotusername',
    component: Home,
    title: 'Forgot Username'
  },
  {
    path: '/myaccount',
    name: 'account',
    component: Account,
    beforeEnter: requireAuth,
    title: 'Profile'
  },
  {
    path: '/mydocuments',
    name: 'documents',
    component: Documents,
    beforeEnter: requireAuth,
    title: 'Documents'
  },
  {
    path: '/logoff',
    name: 'logoff',
    component: Logoff,
    title: 'Log off'
  },
  {
    path: '/terms-conditions',
    name: 'conditions',
    component: Conditions,
    title: 'Terms & Conditions'
  }
]
const router = new Router({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  },
  base: process.env.BASE_URL,
  routes: routes
})

router.beforeEach((to, from, next) => {
  let site = ' | My Alerus'
  let page = routes.find(x => x.name === to.name).title
  if (!page) page = ''

  let sub = window.location.host.split(".")[0]
  if (sub.includes("retirement")) {
    Store.commit("user/setRetirementBranded", true)
  } else if (sub.includes("mers")) {
    Store.commit("user/setMERSBranded", true)
    site = ' | MyMERS'
  }

  document.title = page + site

  next()
})

async function requireAuth(to, from, next) {
  if (Store.getters["user/isAuthenticated"]) {
    next()
  }
  else {
    if (await Store.dispatch("user/checkUser", to)) {
      next()
    }
    else {
      if (to.path === "/") {
        next()
      }
      else next("/")
    }
  }
}

export default router